<div class="card panel-monsido-card d-flex flex-column">
    <mon-panel-header [pHeader]="panelHeaderTitle"></mon-panel-header>
    <div class="card-body flex-fill">
        <div class="row">
            <div class="col-md-48 col-lg-24 mt-4 mb-6" *ngFor="let notification of notificationList; let index = index; trackBy: trackByIndex">
                <mon-spinner [progress]="notification.loading">
                    <notification
                        [link]="notification.link"
                        [params]="notification.linkParams"
                        [faIcon]="notification.faIcon + ' fa-3x'"
                        [title]="notification.title"
                        [digit]="notification.count"
                        [classColor]="notification.classColor"
                        [monAriaButtonText]="notification.title"
                        [monAriaIconText]="notification.title">
                        <span *ngIf="notification.affections">
                            (Affections {{ notification.affections | monNumber }} pages)
                        </span>
                    </notification>
                    <span [hidden]="index % 2 !== 0 || screenWidth < 1200" class="vertical-ruler bg-grey vertical-ruler-right vertical-ruler-1"></span>
                </mon-spinner>
            </div>
        </div>
    </div>
</div>
